module.exports = __webpack_public_path__ + "static/media/needs-11.46471ddb.png";